import { getAddressDetails, getUserAddressDetails } from '@fetch/address';
import * as addressApiV2 from '@fetch/addressV2';

const state = {
  addressList: [],
  opertionsAddressId: 0,
  currentAddressItem: null,
  deleteAddressState: false,
  addAddressStatus: false, // 地址是否添加成功
};

const getters = {
  getAddAddressStatus: (state) => state.addAddressStatus,
};

const actions = {
  async editAddress({ dispatch }, data) {
    await addressApiV2.updateUserAddressV2(data).then((resData) => {      
      dispatch('getAddressDetailByAddressId', {
        userAddressId: data.addressId || resData.resultId,
      });
    });
  },
  async addAddress({ dispatch }, data) {
    await addressApiV2.createUserAddressV2(data).then((resData) => {
      dispatch('getAddressDetailByAddressId', {
        userAddressId: resData.resultId,
      });
    });
  },
  deleteAddress({ commit }, data) {
    addressApiV2.deleteUserAddressV2(data).then(() => {
      commit('setDeleteAddressState');
    });
  },
  getAddressDetailByAddressId({ commit }, data) {
    getUserAddressDetails(data).then((res) => {
      commit('setCurrentAddressItem', res);
    });
  },
  getAddressDetailById({ commit }, data) {
    getAddressDetails(data).then((res) => {
      commit('setCurrentAddressItem', res);
    });
  },
};

const mutations = {
  setOpertionAddressId(state, id) {
    state.opertionsAddressId = id;
  },
  setCurrentAddressItem(state, item) {
    state.currentAddressItem = item;
  },
  setDeleteAddressState(state) {
    state.deleteAddressState = true;
  },
  setAddressList(state, res) {
    state.addressList = res;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
